import React from 'react'
import { SubscriptionTypeTypes } from '@/modules/base/util/constants'
import StartTrialModal from '@/modules/moduleSubscription/components/start-trial-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'
interface openStartTrialModal {
  subscriptionType: keyof typeof SubscriptionTypeTypes,
  onSuccess?: () => void,
  onClose?: () => void,
}

export default (options: openStartTrialModal) => {
  const { subscriptionType, onSuccess, onClose } = options

  const getComponent = (close) => (
    <StartTrialModal
      open={true}
      productType={subscriptionType}
      onSuccess={() => {
        close()
        onSuccess?.()
      }}
      onClose={() => {
        close()
        onClose?.()
      }} />
  )

  renderElement(getComponent)
}
